export const isExcelValid = (item, row, stateCd, acNo, onReject) => {
  let msg = ''
  let isValid = true

  let nullItem = nullValidator(item)
  if (nullItem) {
    msg += nullItem + ' cannot be null'
    isValid = false
  } else if (item.ST_CODE != stateCd) {
    msg += "State '" + item.ST_CODE + "' is not matched with your State"
    isValid = false
  } else if (item.AC_NO != acNo) {
    msg += "AC Number '" + item.AC_NO + "' is not matched with your Ac Number"
    isValid = false
  }

  msg += ' at row ' + (row+1)
  if (!isValid) onReject(msg)
  return isValid
}

const nullValidator = (items) => {
  if (
    items['AC_NO'] === '' ||
    items['AC_NO'] === null ||
    items['AC_NO'] === undefined
  ) {
    return 'AC_NO'
  }
  if (
    items['ST_CODE'] === '' ||
    items['ST_CODE'] === null ||
    items['ST_CODE'] === undefined
  ) {
    return 'ST_CODE'
  }
  if (
    items['SLNOINPART'] === '' ||
    items['SLNOINPART'] === null ||
    items['SLNOINPART'] === undefined
  ) {
    return 'SLNOINPART'
  }
  if (
    items['FULL_NAME'] === '' ||
    items['FULL_NAME'] === null ||
    items['FULL_NAME'] === undefined
  ) {
    return 'FULL_NAME'
  }
  if (
    items['ADDRESS'] === '' ||
    items['ADDRESS'] === null ||
    items['ADDRESS'] === undefined
  ) {
    return 'ADDRESS'
  }
  if (
    items['SRVC_CATY'] === '' ||
    items['SRVC_CATY'] === null ||
    items['SRVC_CATY'] === undefined
  ) {
    return 'SRVC_CATY'
  }
  if (
    items['BUCKLE_NO'] === '' ||
    items['BUCKLE_NO'] === null ||
    items['BUCKLE_NO'] === undefined
  ) {
    return 'BUCKLE_NO'
  }
  if (
    items['RANK'] === '' ||
    items['RANK'] === null ||
    items['RANK'] === undefined
  ) {
    return 'RANK'
  }
  if (
    items['SERVICE_REG'] === '' ||
    items['SERVICE_REG'] === null ||
    items['SERVICE_REG'] === undefined
  ) {
    return 'SERVICE_REG'
  }
  if (
    items['FORCE_ID'] === '' ||
    items['FORCE_ID'] === null ||
    items['FORCE_ID'] === undefined
  ) {
    return 'FORCE_ID'
  }
  if (
    items['RECORD_OFFICE_CODE'] === '' ||
    items['RECORD_OFFICE_CODE'] === null ||
    items['RECORD_OFFICE_CODE'] === undefined
  ) {
    return 'RECORD_OFFICE_CODE'
  }
  if (
    items['UNIT_OFFICE_CODE'] === '' ||
    items['UNIT_OFFICE_CODE'] === null ||
    items['UNIT_OFFICE_CODE'] === undefined
  ) {
    return 'UNIT_OFFICE_CODE'
  }
  if (
    items['AGE'] === '' ||
    items['AGE'] === null ||
    items['AGE'] === undefined
  ) {
    return 'AGE'
  }
  if (
    items['SEX'] === '' ||
    items['SEX'] === null ||
    items['SEX'] === undefined
  ) {
    return 'SEX'
  }

  return null
}
